import '../../../../pages/Organization/OrganizationOld.scss';

import { Input } from '@trackman/web-shared-components';
import { Modal } from '@trackman/web-shared-components';
import { ReactComponent as PlusIcon } from 'images/icons/Plus.svg';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

export const AddNewClassModal = observer(() => {
  const { t } = useTranslation();
  const cs = useStores().classesStore;
    const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);
  

  return (
    <Modal
      open={cs.isAddClassModalOpen}
      onClose={() => (cs.isAddClassModalOpen = false)}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => (cs.isAddClassModalOpen = false),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Create', { ns: 'organizationPage' }),
        onClick: () => {
          cs.createNewClassAndUpdate(selectedOrganizationId);
          cs.isAddClassModalOpen = false;
          cs.newClass.name = '';
        },
        disabled: cs.newClass.name === '' || cs.isCreatingNewClass,
      }}
      className='organization-modal'
      title={t('CreateNewClass', { ns: 'organizationPage' })}
      titleIcon={<PlusIcon />}
    >
      <div className='modal-body'>
        <p className='name-your-class'>
          <strong>{t('NameYourClass', { ns: 'organizationPage' })}</strong>
        </p>
        <Input
          label={t('ClassName', { ns: 'organizationPage' })}
          value={cs.newClass.name ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => (cs.newClass.name = e.currentTarget.value)}
        />
      </div>
    </Modal>
  );
});

export default AddNewClassModal;
